import { render, staticRenderFns } from "./ConfigInputTextSignatureTemplate.vue?vue&type=template&id=009ca0d2&"
import script from "./ConfigInputTextSignatureTemplate.vue?vue&type=script&lang=js&"
export * from "./ConfigInputTextSignatureTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('009ca0d2')) {
      api.createRecord('009ca0d2', component.options)
    } else {
      api.reload('009ca0d2', component.options)
    }
    module.hot.accept("./ConfigInputTextSignatureTemplate.vue?vue&type=template&id=009ca0d2&", function () {
      api.rerender('009ca0d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/configs/inputs/ConfigInputTextSignatureTemplate.vue"
export default component.exports